import type { ButtonHTMLAttributes, FunctionComponent, ReactNode } from 'react';

import { useModifiers } from '../../styles/hooks/useModifiers';

import styles from './InputButton.module.css';

export interface InputButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** If the button is active */
  active?: boolean;
  /** Icon to be displayed as a part of content*/
  icon?: ReactNode;
}

/**
 * The button for the filter bar
 */
export const InputButton: FunctionComponent<InputButtonProps> = ({
  icon,
  children,
  onClick,
  type = 'button',
  active = false,
  ...rest
}) => {
  const mods = useModifiers(styles, 'inputButton', { active }, { withBaseClass: true });

  return (
    <button type={type} className={mods} onClick={onClick} {...rest}>
      {icon ? <span className={styles.inputButton__icon}>{icon}</span> : ''}
      {children}
    </button>
  );
};
